import { VSecureFileRevokeRequest, VSecureFileRevokeResponse } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
class RevokeFileEndpoint extends EncryptedEndpoint {
    async getRequestInit({ fileId }) {
        const requestBytes = VSecureFileRevokeRequest.encode({
            fileId
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VSecureFileRevokeResponse.decode(responseBytes);
    }
}
export const revokeEndpoint = new RevokeFileEndpoint({
    path: '/encryptions/revoke',
    method: 'POST',
    sideEffect: true,
    body: {},
    schema: VSecureFileRevokeResponse
});
